import BankAddress from "containers/bankAddress";
import BankSelectCard from "containers/bankSelectCard";
import BankVideo from "containers/bankVideo";
import BankInfo from "./baseInfo/baseInfo";

const OnbSteps = ({ current, data, ...props }) => {
  const currentStage = data?.stages?.filter((item) => item.sort === current)[0];

  const handleStepContent = (currentStage) => {
    switch (currentStage?.key) {
      case "BASE_INFO":
        return <BankInfo currentStage={currentStage} data={data} {...props} />;
      case "CARD":
        return (
          <BankSelectCard currentStage={currentStage} data={data} {...props} />
        );
      case "VIDEO":
        return <BankVideo currentStage={currentStage} data={data} {...props} />;
      case "ADDRESS":
        return <BankAddress currentStage={currentStage} {...props} />;

      default:
        return "";
    }
  };

  return handleStepContent(currentStage);
};
export default OnbSteps;
